import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { Grid, Checkbox, TextField, MenuItem } from '@material-ui/core';
import { typography, colors } from '@/styles';

export const Circle = styled.div`
    width: 55px;
    height: 55px;
    border-radius: 999px;
`;

export const Body1 = styled.span`
    ${typography.sansSerif}

    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
`;

export const Label = styled.span`
    ${typography.sansSerif}

    font-weight: 700;
    font-size: 14px;
    line-height: 17px;
`;

export const SubTitle = styled.span`
    ${typography.sansSerif}

    font-weight: 500;
    font-size: 14px;
    line-height: 17px;
`;

const rowStyles = (props) => {
    return css`
        background: ${props.selected ? '#CFCFCF' : '#e5e5e5'};
        cursor: ${props.selected ? 'default' : 'pointer'};
    `;
};

const borderRed = (props) => {
    return css`
        border: ${props.error ? '2px solid #d23e3e' : '2px solid transparent'};
    `;
};

export const ErrorContainer = styled(({ children, ...props }) => (
    <Grid container direction="column" {...props}>
        {children}
    </Grid>
))`
    width: 100%;
    border-radius: 5px;

    ${borderRed}
`;

export const OptionRow = styled(({ children, ...props }) => (
    <Grid container direction="row" {...props}>
        {children}
    </Grid>
))`
    ${rowStyles}
    padding: 16px 12px;

    &:not(:last-child) {
        border-bottom: 1px solid #c0c0c0;
    }

    &:first-of-type {
        border-top-left-radius: 5px;
        border-top-right-radius: 5px;
    }

    &:last-of-type {
        border-bottom-left-radius: 5px;
        border-bottom-right-radius: 5px;
    }
`;
